/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum UiButtonStyle {
    Add = 'add',
    Amber = 'amber',
    Blue = 'blue',
    CLOSE = 'close',
    Cyan = 'cyan',
    DELETE = 'delete',
    Dark = 'dark',
    Disabled = 'disabled',
    EDIT = 'edit',
    Gray = 'gray',
    Green = 'green',
    GradientGreen = 'gradient_green',
    INFO = 'info',
    Indigo = 'indigo',
    LIGHT = 'light',
    Pagination = 'pagination',
    Primary = 'primary',
    Print = 'print',
    Red = 'red',
    SAVE = 'save',
    Secondary = 'secondary',
    White = 'white',
	Whitesmoke = 'whitesmoke',
    Yellow = 'yellow',
}
